import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { Controller, useForm } from 'react-hook-form';
import { $cardStore } from '@lib/store';
import { BaseInput, Button, Modal } from '@shared/widgets';

interface IForm {
  label: string;
  category: string;
}
const DEFAULT_VALUES: IForm = { label: '', category: '' };

interface CardDetailsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CardDetailsModal = (props: CardDetailsModalProps) => {
  const cardStore = useUnit($cardStore.store);

  const { control, formState, handleSubmit, reset } = useForm<IForm>({
    defaultValues: { ...DEFAULT_VALUES, label: cardStore.data?.cardLabel || '', category: cardStore.data?.category || '' },
  });

  const { t } = useTranslation('card');

  const closeHandler = () => {
    props.onClose();
    reset({ ...DEFAULT_VALUES, label: cardStore.data?.cardLabel || '', category: cardStore.data?.category || '' });
  };
  const submitHandler = async (data: IForm) => {
    await Promise.allSettled([
      data.label !== cardStore.data?.cardLabel && $cardStore.events.updateLabelCard({ cardId: cardStore.data!.cardId, cardLabel: data.label }),
      data.category !== cardStore.data?.category && $cardStore.events.updateCategoryCard({ cardId: cardStore.data!.cardId, category: data.category }),
    ]);
    props.onClose();
  };

  return (
    <Modal isOpen={props.isOpen} onClose={closeHandler} title={t('sidebar.modals.cardDetails.title')}>
      <form className='flex flex-col gap-5' noValidate onSubmit={handleSubmit(submitHandler)}>
        <Controller
          name='label'
          control={control}
          rules={{ maxLength: { value: 25, message: t('errors.form.maxCharacters', { ns: 'common', max: 25 }) } }}
          render={({ field }) => (
            <BaseInput
              {...field}
              label={t('sidebar.modals.cardDetails.placeholders.cardLabel')}
              placeholder={t('sidebar.modals.cardDetails.placeholders.cardLabel')}
            />
          )}
        />
        <Controller
          name='category'
          control={control}
          rules={{ maxLength: { value: 25, message: t('errors.form.maxCharacters', { ns: 'common', max: 25 }) } }}
          render={({ field }) => (
            <BaseInput
              {...field}
              label={t('sidebar.modals.cardDetails.placeholders.cardCategory')}
              placeholder={t('sidebar.modals.cardDetails.placeholders.cardCategory')}
            />
          )}
        />
        <Button className='mt-2' fullWidth color='primary' type='submit' disabled={formState.isSubmitting}>
          {t('buttons.saveChanges', { ns: 'common' })}
        </Button>
      </form>
    </Modal>
  );
};
